import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bd56c4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "usage-guide-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], {
          title: $setup.guideInfo?.title ?? '이용안내'
        }, null, 8 /* PROPS */, ["title"]),
        _createVNode($setup["Tutorial"], {
          class: "tutorial-container",
          guideInfo: $setup.guideInfo
        }, null, 8 /* PROPS */, ["guideInfo"])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}